<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 53, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_599" data-name="Rectangle 599" width="115.797" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Top_three_content_essentials" data-name="Top three content essentials" transform="translate(40 51.446)"
          fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">Top three content essentials</tspan>
    </text>
    <text id="Insights_that_address_a_key_challenge_" data-name="Insights that address a
key challenge " transform="translate(40 343)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">Insights that address a</tspan>
        <tspan x="0" y="46">key challenge</tspan>
    </text>
    <text id="_53_" data-name="53%" transform="translate(100 172)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="27.171" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1199" data-name="Group 1199" transform="translate(163 100)">
        <g id="Group_1198" data-name="Group 1198" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14613" data-name="Path 14613" d="M18.012,7.061A96.785,96.785,0,1,1,1,199.14" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14614" data-name="Path 14614" d="M12.769,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                  fill="#fff"/>
            <path id="Path_14615" data-name="Path 14615" d="M12.769,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,12.769,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
</svg>
